<template>
  <div class="vertical-center text-center">
    <p id="svg-sad">
      <SadSvg />
    </p>
    <p>{{ message }}</p>
    <b-button
      variant="outline-primary"
      @click="$store.dispatch('application/close')"
      >{{ buttonText }}
    </b-button>
  </div>
</template>

<script>
import SadSvg from "./../../assets/images/sad.svg";

export default {
  name: "pages-page-params",
  components: {
    SadSvg
  },
  data() {
    return {
      message: "Product information is missing.",
      buttonText: "Close"
    };
  }
};
</script>

<style scoped>
.vertical-center {
  margin-top: 25%;
}

#svg-sad svg {
  margin-bottom: 30px;
}
</style>
